module.exports = __webpack_public_path__ + "img/avatar4.8b3270f5.png";